<template>
  <BlockImg :modelValue="value?value.uuid:null" v-on:update:modelValue="selectItem" />
</template>

<script>
import api from '@/Util/api';

export default {
  props: ["modelValue", "field", "item", "field", "dbfield"],
  data: ()=>({
    value: null,
  }),
  watch: {
    value: {
      handler() {
        this.$emit("update:modelValue", this.value);
      },
    },
    modelValue: {
      handler() {
        this.value=this.modelValue;
      }, immediate: true,
    },
  },
  methods: {
    createLink(type) {
      return {
        name: "page",
        params: {
          path: [...this.$route.params.path, type],
        }
      }
    },
    selectItem() {
      this.stores.callbacks.pushCallback((...args)=>this.select(...args));
      this.$router.push(this.createLink(this.dbfield.target));
    },
    async selectItem(newValue) {
      if (newValue==null || newValue=="")
        this.value=null;
      else
        this.value=await api.get("File", newValue);
    },
  },
}
</script>
